/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
let map;

function initMapAfterAjax(mapElement) {
  var jsonLocation = mapElement.dataset.pinsjson;

  const xmlhttp = new XMLHttpRequest();
  xmlhttp.onload = function () {
    const jsonData = JSON.parse(this.responseText);
    //document.getElementById("demo").innerHTML = myObj.name;
  
  setTimeout(function(){initMap(jsonData);},1000); // weil asynch aus irgendeinem grund nicht nachkommt... keine Ahnung
  };
  xmlhttp.open("GET", jsonLocation);
  xmlhttp.send();
}

function getInfoFensterHTML(data) {
  var name = data.name1;
  name = data.name2 ? name + " <br> " + data.name2 : name;

  var returndata = `<div class="infoboxgmaps">
  <p><strong>${name}</strong></p>
  <p> ${data.strasse} <br>
  ${data.plz} ${data.ort} ${data.land} <br>
  ${data.tel}<br>
  <a target="_blank" href="https://${data.web}">${data.web}</a> </p>
  </div>`;

  return returndata;
}
//sta
async function initMap(jsonData) {
  var mapcontainers = document.getElementsByClassName("googlemapcontainer");
  
  try {
    
  const { Map } = await google.maps.importLibrary("maps");

  var openedwindow = undefined;

  /* damit daten einstellbar sind */ 
  var mapElement = document.getElementById("map");
  var mapZoom = parseFloat(mapElement.dataset.zoom);
  var mapLat = mapElement.dataset.lat;
  var mapLng = mapElement.dataset.lng;

  const features = [];

  
    for (var i = 0; i < jsonData.length; i++) {
      features[i] = {
        position: new google.maps.LatLng(jsonData[i].lat, jsonData[i].lng),
        type: "findliveye",
        title: jsonData[i].title,
        infowindowcontent: getInfoFensterHTML(jsonData[i].infocontent),
      };
    }

    if (navigator.geolocation) {
      //console.log(navigator.geolocation);
      navigator.geolocation.getCurrentPosition(function (position) {
        initialLocation = new google.maps.LatLng(
          position.coords.latitude,
          position.coords.longitude
        );
        map.setCenter(initialLocation);
      });
    }

    map = new google.maps.Map(mapElement, {
      center: new google.maps.LatLng(mapLat, mapLng),
      zoom: mapZoom,
    });

    const iconBase =
      "https://www.liveye.com/wp-content/themes/rdts/assets/src/img/";
    const icons = {
      findliveye: {
        icon: iconBase + "mapmarker.svg",
      },
      parking: {
        icon: iconBase + "parking_lot_maps.png",
      },
      library: {
        icon: iconBase + "library_maps.png",
      },
      info: {
        icon: iconBase + "lupe_red.svg",
      },
    };

    // Create markers.
    const markers = [];
    for (let i = 0; i < features.length; i++) {
      const marker = new google.maps.Marker({
        position: features[i].position,
        icon: icons[features[i].type].icon,
        title: features[i].title,
        map: map,
      });
      markers.push(marker);
      const infowindow = new google.maps.InfoWindow({
        content: features[i].infowindowcontent,
        ariaLabel: features[i].title,
      });

      marker.addListener("click", () => {
        if (openedwindow) {
          openedwindow.close();
        }

        infowindow.open({
          anchor: marker,
          map,
        });
        openedwindow = infowindow;
      });
    }
    // cluster müsste erst installiert werden https://developers.google.com/maps/documentation/javascript/marker-clustering?hl=de
    //console.log(markers);
    //new MarkerClusterer({ features, map });
    for (var i = 0; i < mapcontainers.length; i++) {
      mapcontainers[i].classList.remove("cookieerrormap");
    }
  } catch (error) {
    for (var i = 0; i < mapcontainers.length; i++) {
      mapcontainers[i].classList.add("cookieerrormap");
    }

    console.error(error);

    // Expected output: ReferenceError: nonExistentFunction is not defined
    // (Note: the exact output may be browser-dependent)
  }
}

if (document.getElementById("map")) {
  //window.initMap = initMap;
  //console.log(document.getElementById("map"));
  initMapAfterAjax(document.getElementById("map"));
}
